export enum ActionTypes {
  INITIALIZE = 'INITIALIZE'
}

export type InitializeAction = {
  type: ActionTypes.INITIALIZE;
  payload: boolean;
};

export type Action = InitializeAction;

export type AuthState = {
  isInitialized: boolean;
  isAuthenticated: boolean;
};
